import { create } from 'zustand';

interface OpenHoverCardState {
    openCardId: string | null;
    open: (cardId: string) => void;
    close: (cardId: string) => void;
}

export const useOpenHoverCard = create<OpenHoverCardState>((set) => ({
    openCardId: null,
    open: (cardId) => set({ openCardId: cardId }),
    close: (cardId) =>
        set((state) =>
            state.openCardId === cardId ? { openCardId: null } : state,
        ),
}));
